export const MISC_HISTORY_FIELD_MAP = {
  'Filing Type': { id: 'FilingType' },
  'Filing Number': { id: 'FilingNumber' },
  'Received Date': { id: 'ReceivedDate' },
  'Processed Date': { id: 'ProcessedDate' },
  DLN: { id: 'Dln', type: 'dln' },
  'Receipt Number': { id: 'ReceiptNumber', type: 'receiptnum' },
  'Receipt Amount': { id: 'ReceiptAmount', type: 'amount' },
  Status: { id: 'Status' },
  'Entry Type': { id: 'EntryType' },
  'Created By User': { id: 'CreatedByUser' },
  'Last Modified By User': { id: 'LastModifiedByUser' },
  'Processed By User': { id: 'ProcessedByUser' },
}

export const buildMiscHistoryTemplate = (historyConfig) => {
  if (!historyConfig || !historyConfig.IsEnabled) return []
  const template = (historyConfig.Fields || [])
    .filter((f) => f.IsEnabled && MISC_HISTORY_FIELD_MAP[f.FieldName])
    .slice()
    .sort((a, b) => a.SortOrder - b.SortOrder)
    .map((f) => ({
      id: MISC_HISTORY_FIELD_MAP[f.FieldName].id,
      type: MISC_HISTORY_FIELD_MAP[f.FieldName].type,
      label: f.Label || f.FieldName,
    }))
  if (historyConfig.IsVoidable) {
    template.push({ type: 'voidbutton', id: 'voidInfo', label: 'Void' })
  }
  if (historyConfig.AllowCorrespondenceDownloads) {
    template.push({ type: 'correspondence', id: 'Correspondence', label: 'Correspondence' })
  }
  return template
}

export const mapMiscFilingEntry = (entry) => ({
  ...entry,
  Id: entry.MiscellaneousFilingId,
  FilingDate: entry.ReceivedDate,
  CATEGORY: 'miscellaneous',
  HistoryDetails: (entry.FieldChanges || []).map((c, i) => ({
    HistoryId: i,
    DisplayName: c.FieldLabel,
    ChangedFrom: c.ChangedFrom,
    ChangedTo: c.ChangedTo,
  })),
  voidInfo: {
    VoidDate: entry.VoidDate,
    VoidedBy: entry.VoidedBy,
    VoidReason: entry.VoidReason,
  },
})

export const buildMiscHistoryAmendments = (filingHistory) =>
  ((filingHistory && filingHistory.Filings) || []).map(mapMiscFilingEntry)
